/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCastleFlag: {
  name: 'castle_flag';
  data: string;
} = {
  name: 'castle_flag',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M489.479 13.644v80.978h-56.544V13.644h-92.844v80.978h-55.847V13.644H191.4v80.978h-55.847V13.644H42.709l-.006-.003v135.428l79.582 75.393v220.595c42.801 55.699 104.576 106.826 189.182 155.674 86.493-49.938 148.648-103.361 191.275-159.86V224.465l79.582-75.393V13.644h-92.845zM312.86 327.482H177.432V197.238l-55.847-52.358H312.86v182.602zm134.732 89.654c-29.824 39.564-73.923 77.347-134.032 112.39V328.88h134.032v88.256z"/></svg>`,
};
